import Notification from '@/app/apis/main/notification/notification-api.js';

export default {
    /**
    * @returns {object} notification list
    */
    async getNotification(petId, notificationDetails) {
        return Notification.getNotification(petId, notificationDetails);
	},
	
	/**
    * @params {*} notificationSchedule 
    */
	async putNotification(notificationScheduleId) {
		return Notification.putNotification(notificationScheduleId);
	},

    /**
     * Marks all user notifications as read.
     * @returns {Promise} A promise that resolves when the operation is complete.
     */
    async markAllAsReadNotifications() {
        return Notification.markAllAsReadNotifications();
    }
    
};